/** Цвета тегов статуса назначения — как в таблице (RecordsTab). */
export const trainingAssignmentStatusTagColor: Record<
  string,
  'success' | 'warning' | 'error' | 'processing' | 'default'
> = {
  passed: 'success',
  assigned: 'processing',
  in_progress: 'processing',
  overdue: 'error',
  not_passed: 'error',
  not_admitted: 'warning',
  cancelled: 'default',
};
